{
  "Accessibility Menu": "قائمة إمكانية الوصول",
  "Reset settings": "إعادة تعيين الإعدادات",
  "Close": "إغلاق",
  "Content Adjustments": "تعديلات المحتوى",
  "Adjust Font Size": "تعديل حجم الخط",
  "Highlight Title": "تسليط الضوء على العنوان",
  "Highlight Links": "تسليط الضوء على الروابط",
  "Readable Font": "خط سهل القراءة",
  "Color Adjustments": "تعديلات الألوان",
  "Dark Contrast": "تباين داكن",
  "Light Contrast": "تباين فاتح",
  "High Contrast": "تباين عالي",
  "High Saturation": "تشبع عالي",
  "Low Saturation": "تشبع منخفض",
  "Monochrome": "أحادي اللون",
  "Contrast": "التباين",
  "Invert Colors": "عكس الألوان",
  "Tools": "أدوات",
  "Reading Guide": "دليل القراءة",
  "Stop Animations": "إيقاف الرسوم المتحركة",
  "Big Cursor": "مؤشر كبير",
  "Increase Font Size": "زيادة حجم الخط",
  "Decrease Font Size": "تقليل حجم الخط",
  "Letter Spacing": "تباعد الحروف",
  "Line Height": "ارتفاع السطر",
  "Font Weight": "سماكة الخط",
  "Dyslexia Font": "خط القراءة لمن يعانون من عسر القراءة",
  "Language": "اللغة",
  "Open Accessibility Menu": "افتح قائمة الوصول",
  "Widget Settings": "إعدادات الويدجت",
  "Widget Position": "موضع الويدجت",
  "Top Left": "أعلى اليسار",
  "Top Center": "أعلى الوسط",
  "Top Right": "أعلى اليمين",
  "Center Left": "الوسط يسار",
  "Center Right": "الوسط يمين",
  "Bottom Left": "أسفل اليسار",
  "Bottom Center": "أسفل الوسط",
  "Bottom Right": "أسفل اليمين",
  "Screen Reader": "قارئ الشاشة",
  "Voice Navigation": "التنقل الصوتي",
  "Custom Color": "لون مخصص",
  "Change the site's colors": "غيّر ألوان الموقع",
  "Backgrounds": "الخلفيات",
  "Headings": "العناوين",
  "Contents": "المحتويات",
  "Reset colors": "إعادة تعيين الألوان",
  "Image Desaturation": "إزالة تشبع الصور",
  "Search languages": "ابحث عن اللغات",
  "No languages found": "لم يتم العثور على لغات",
  "Accessibility Profiles": "ملفات إمكانية الوصول",
  "Motor Impaired": "إعاقة حركية",
  "Big cursor, voice navigation, and no animations.": "مؤشر كبير، تنقل صوتي وبدون حركات.",
  "Blind": "كفيف",
  "Screen reader helpers with higher contrast.": "مساعدات قارئ الشاشة مع تباين أعلى.",
  "Color Blind": "عمى الألوان",
  "High contrast palette with desaturated media.": "لوحة عالية التباين مع وسائط منخفضة التشبع.",
  "Dyslexia": "عسر القراءة",
  "Friendly font, extra spacing, stronger weight.": "خط مريح، مسافات إضافية وسمك أكبر.",
  "Low vision": "ضعف البصر",
  "Dark contrast and 130% magnification.": "تباين داكن وتكبير بنسبة 130٪.",
  "Cognitive & Learning": "إدراكي وتعلمي",
  "Highlights key sections and enables voice help.": "يبرز الأقسام المهمة ويفعل المساعدة الصوتية.",
  "Seizure & Epileptic": "نوبات صرع",
  "Stops animations and desaturates imagery.": "يوقف الحركات ويقلل تشبع الصور.",
  "ADHD": "اضطراب فرط الحركة ونقص الانتباه",
  "Reading guide, highlighted links, calmer palette.": "دليل قراءة، روابط مميزة ولوحة ألوان أكثر هدوءًا.",
  "Widget Size": "حجم الأداة",
  "Default": "افتراضي",
  "Medium": "متوسط",
  "Small": "صغير",
  "Color Blindness": "عمى الألوان",
  "Protanopia": "عمى الأحمر",
  "Deuteranopia": "عمى الأخضر",
  "Tritanopia": "عمى الأزرق",
  "Achromatopsia": "عمى الألوان الكلي",
  "Simulates and assists users with color vision deficiencies.": "يحاكي ويساعد المستخدمين الذين يعانون من قصور في رؤية الألوان."
}
